/** Nombre max de photos par avis (aligné backend FilesInterceptor). */
export const MAX_REVIEW_IMAGES = 5;

/** Champ multipart attendu par POST /products/:id/images. */
export const PRODUCT_IMAGE_FIELD = 'images';

/** Champ multipart attendu par POST /reviews (avec fichiers). */
export const REVIEW_IMAGE_FIELD = 'images';

/**
 * FormData pour l'upload d'images produit (POST /products/:id/images).
 * @param {File[]} files
 * @returns {FormData}
 */
export function buildProductImagesFormData(files = []) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append(PRODUCT_IMAGE_FIELD, file);
  });
  return formData;
}

/**
 * FormData pour créer un avis avec photos (POST /reviews multipart).
 * Sans fichiers, utiliser POST JSON via productsAPI.createProductReview.
 * @param {{ productId: string, rating: number, comment?: string, recaptchaToken?: string }} reviewData
 * @param {File[]} files
 * @returns {FormData}
 */
export function buildReviewFormData(reviewData, files = []) {
  const formData = new FormData();
  formData.append('productId', reviewData.productId);
  formData.append('rating', String(reviewData.rating));
  if (reviewData.comment) {
    formData.append('comment', reviewData.comment);
  }
  if (reviewData.recaptchaToken) {
    formData.append('recaptchaToken', reviewData.recaptchaToken);
  }
  files.slice(0, MAX_REVIEW_IMAGES).forEach((file) => {
    formData.append(REVIEW_IMAGE_FIELD, file);
  });
  return formData;
}
